module.exports = __webpack_public_path__ + "img/lukito.16c8ba45.png";